﻿import {
  HttpResponse,
  HttpStatusCode,
} from '@antecipa/core/http/interfaces';

export function CorporateLoginHandler(response: HttpResponse) {
  if (response.status === HttpStatusCode.noContent) {
    return { endpoint: '', error: false };
  } else {
    if (response.status !== HttpStatusCode.ok) {
      return { endpoint: '', error: true };
    }
  }
  return { endpoint: response.data.endpoint, error: false };
}
